<template>
  <div class="base">
    <div class="base__header" />
    <main class="base__body">
      <slot />
    </main>
    <div class="base__footer" />
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
</style>
